import { render, staticRenderFns } from "./VAdministrationMain.vue?vue&type=template&id=3c581e18&functional=true&"
var script = {}
import style0 from "./VAdministrationMain.vue?vue&type=style&index=0&id=3c581e18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports